import React, { useState } from 'react';
import classnames from 'classnames';
import { useIntl, history, getLocale } from 'umi';
import { Layout, Tab } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { PCU, MAU, DigitalRevenue, PhysicalRevenue } from './tabs';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';
import '@/pages/intelligence/assets/scss/Compare/pcConsoleGames.scss';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import NpdIcon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';

const { Body, Content } = Layout;

export default function PCConsoleGames(props: any) {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  const tabs = [
    {
      id: 'pcu',
      label: (
        <div className="dbi-page-tabs-label">
          <img className="dbi-page-tabs-label-icon" src={SteamIcon} />
          <span className="dbi-page-tabs-label-text">{formatMessage({ id: 'dbi_metric_pcu' })}</span>
        </div>
      ),
      component: <PCU />,
    },
    {
      id: 'mau',
      label: (
        <div className="dbi-page-tabs-label">
          <img className="dbi-page-tabs-label-icon" src={NewzooIcon} />
          <span className="dbi-page-tabs-label-text">{formatMessage({ id: 'dbi_metric_mau' })}</span>
        </div>
      ),
      component: <MAU />,
    },
    {
      id: 'digitalRevenue',
      label: (
        <div className="dbi-page-tabs-label">
          <img className="dbi-page-tabs-label-icon" src={MscienceIcon} />
          <span className="dbi-page-tabs-label-text">{formatMessage({ id: 'dbi_metric_digitalRevenueNoDo' })}</span>
        </div>
      ),
      component: <DigitalRevenue />,
    },
    {
      id: 'physicalRevenue',
      label: (
        <div className="dbi-page-tabs-label">
          <img className="dbi-page-tabs-label-icon" src={NpdIcon} />
          <span className="dbi-page-tabs-label-text">{formatMessage({ id: 'dbi_metric_physical_revenue1' })}</span>
        </div>
      ),
      component: <PhysicalRevenue />,
    },
  ];

  const [activeId, setActiveId] = useState(props?.match?.params?.tab || 'pcu');

  const handleActiveIdChange = (tab: Tab) => {
    setActiveId(tab.id);
    history.replace(`/intelligence/compare/pcConsoleGames/${tab.id}`);
  };

  return (
    <Layout className={classnames('dbi-compare-pc-console', { 'is-cn': isCN })}>
      <Body>
        <Content>
          <Content.Header className="contentHead-normal" title={formatMessage({ id: 'dbi_compare_pc_console_title' })}>
            <div className="header-tab">
              <Tabs
                className="dbi-page-tabs"
                newMarkIdsMappingKey="ComparePCConsoleGames"
                ceiling={true}
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={handleActiveIdChange}
              />
            </div>
          </Content.Header>
          <Content.Body full>
            {tabs.map((e) => (
              <div key={e.id}>{e.id === activeId ? e.component : ''}</div>
            ))}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
}
